import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';

const IconCheckboxTemplate = function({ checked, onChange, checkedIconClass, unCheckedIconClass }) {
    return (
        <React.Fragment>
            <span className='c-pointer' onClick={()=> onChangeChecked(checked,onChange)}><i className={`u-icon u-icon--sml ${( checked ? checkedIconClass : unCheckedIconClass)}`}></i></span>
        </React.Fragment>
    );
}

function onChangeChecked(checked,onChange){
    checked = !checked;
    onChange(checked);
}

IconCheckboxTemplate.propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.any,
    checkedIconClass: PropTypes.string,
    unCheckedIconClass: PropTypes.string,
};

export default defaultTemplate(IconCheckboxTemplate);
